import UserCard from 'common/components/UserCard'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import Personal from '../components/Personal'

const DocPersonal = ({ object }) => {
  const location = useLocation()
  const [user] = useState(location?.state?.user ?? null)
  const [userData, _] = useState({
    user: location?.state?.user ?? null,
    surname: location?.state?.surname ?? null,
    name: location?.state?.name ?? null,
    image: location?.state?.image ?? null,
  })

  return (
    <>
      {user ? <UserCard datos={userData} /> : null}
      <Personal forcedLevel={object} />
    </>
  )
}

export default DocPersonal
